export const VerifiedorganisationExcelHeaders = [
  { label: 'Id', key: 'id' },
   { label: 'District', key: 'organization.ref_district.name' },
  { label: 'Registration Number', key: 'organization.registration_number' },
  { label: 'Atom Id', key: 'atom_id' },
  { label: 'Insitution Name', key: 'organization.name_of_organization' },
   { label: 'User Type', key: 'organization.user_category_sub_type.sub_category_name' },
  { label: 'Official Email Address', key: 'email' },
  { label: 'Official Mobile Number', key: 'organization.mobile' },
  { label: 'Contact Person Name', key: 'organization.contact_person_name' },
  { label: 'Contact Person Email', key: 'organization.contact_person_email' },
  { label: 'Contact Person Mobile Number', key: 'organization.contact_person_contact' },
  
 
  
];